import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import { dateButtonCompact, dateButton, activeOverlay, focusOverlay, hoverOverlay } from "./DateButton.css.mjs";
const DateButtonOverlay = ({
  background,
  borderRadius,
  children,
  className,
  visible = false
}) => /* @__PURE__ */ jsx(
  Box,
  {
    position: "absolute",
    pointerEvents: "none",
    background,
    borderRadius,
    transition: "fast",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    opacity: !visible ? 0 : void 0,
    className,
    children
  }
);
const DateButton = ({
  children,
  isActive,
  isCompact = false,
  onClick,
  value
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    background: isActive ? "formAccent" : void 0,
    borderRadius: "full",
    className: isCompact ? dateButtonCompact : dateButton,
    component: "button",
    cursor: "pointer",
    "data-value": value,
    display: "block",
    outline: "none",
    position: "relative",
    transform: { active: "touchable" },
    transition: "touchable",
    onClick,
    children: [
      /* @__PURE__ */ jsx(
        DateButtonOverlay,
        {
          background: isActive ? "formAccentActive" : void 0,
          borderRadius: "full",
          className: activeOverlay
        }
      ),
      /* @__PURE__ */ jsx(
        DateButtonOverlay,
        {
          background: isActive ? "formAccentActive" : void 0,
          borderRadius: "full",
          className: focusOverlay
        }
      ),
      /* @__PURE__ */ jsx(
        DateButtonOverlay,
        {
          background: isActive ? "formAccentHover" : void 0,
          borderRadius: "full",
          className: hoverOverlay
        }
      ),
      /* @__PURE__ */ jsx(Box, { position: "relative", children: /* @__PURE__ */ jsx(Text, { size: isCompact ? "xsmall" : "small", children }) })
    ]
  }
);
export {
  DateButton,
  DateButtonOverlay
};
